import { FunctionsError, FunctionsHttpError } from '@supabase/supabase-js'

/**
 * The edge function's own error line, for a toast. supabase-js surfaces every
 * non-2xx as "Edge Function returned a non-2xx status code" and every network
 * or gateway failure with a similarly technical line; the body carries the
 * reason we actually want to show — "Out of credits" from the credit
 * pre-flight, a validation message, a conflict.
 *
 * A supabase-js message is never shown as-is: when the body has nothing for
 * the user (a gateway 503, a relay error, a non-JSON body), the caller's
 * fallback is what they see.
 */
export async function edgeFunctionErrorMessage(
  error: unknown,
  fallback: string
): Promise<string> {
  if (error instanceof FunctionsHttpError) {
    try {
      const body = (await error.context.json()) as { error?: unknown }
      if (typeof body.error === 'string' && body.error.length > 0) {
        return body.error
      }
    } catch {
      // Non-JSON body — fall through to the fallback.
    }
  }
  if (error instanceof FunctionsError) {
    return fallback
  }
  return error instanceof Error && error.message ? error.message : fallback
}
